(function () {

	const routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
	const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
	const cartUrl = routes.cart_url || root + 'cart';
	const addUrl = (routes.cart_add_url || cartUrl + '/add') + '.js';
	const changeUrl = (routes.cart_change_url || cartUrl + '/change') + '.js';

	const esc = str => String(str).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
	const fill = (str, map) => String(str || '').replace(/\[(\w+)\]/g, (m, k) => (k in map ? map[k] : m));

	function formatMoney(cents, format) {
		const fmt = format || '€{{amount_with_comma_separator}}';
		return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
			const comma = key.indexOf('comma_separator') > -1;
			const noDecimals = key.indexOf('no_decimals') > -1;
			const [int, dec] = (cents / 100).toFixed(noDecimals ? 0 : 2).split('.');
			const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
			return noDecimals ? grouped : grouped + (comma ? ',' : '.') + dec;
		});
	}

	// Same refresh the theme's cart drawer uses (component-cart.js), without opening the drawer
	function updateDrawer(html) {
		if ( ! html ) return false;
		const doc = new DOMParser().parseFromString(html, 'text/html');
		const form = document.getElementById('AjaxCartForm');
		const newForm = doc.getElementById('AjaxCartForm');
		if ( ! form || ! newForm ) return false;
		form.innerHTML = newForm.innerHTML;
		if ( typeof form.ajaxifyCartItems === 'function' ) form.ajaxifyCartItems();
		const count = form.querySelector('[data-cart-count]');
		const total = form.querySelector('[data-cart-total]');
		document.querySelectorAll('[data-header-cart-count]').forEach(elm => { if ( count ) elm.textContent = count.textContent; });
		document.querySelectorAll('[data-header-cart-total]').forEach(elm => { if ( total ) elm.textContent = total.textContent; });
		const subtotal = document.getElementById('AjaxCartSubtotal');
		const newSubtotal = doc.getElementById('AjaxCartSubtotal');
		if ( subtotal && newSubtotal ) subtotal.innerHTML = newSubtotal.innerHTML;
		return true;
	}

	function init(el) {

		if ( el.dataset.oltReady ) return;
		el.dataset.oltReady = 'true';

		const config = JSON.parse(el.querySelector('[data-olt-config]').textContent);
		const tiers = config.tiers.slice().sort((a, b) => b.q - a.q);
		const lowest = tiers[tiers.length - 1];
		const top = tiers[0];
		const t = config.t;
		const money = cents => formatMoney(cents, config.moneyFormat);
		const $ = sel => el.querySelector(sel);
		const bar = $('[data-olt-bar]');

		// variant id -> unit price for every product shown on this page (= the offer's products)
		const prices = {};
		el.querySelectorAll('[data-olt-card]').forEach(card => {
			prices[card.querySelector('.olt-cta').dataset.id] = parseInt(card.dataset.price, 10);
		});

		let cart = {};
		let cartCount = 0;

		const readCart = (items, count) => {
			cart = {};
			cartCount = count || 0;
			items.forEach(item => {
				const id = String(item.variant_id || item.v);
				const qty = item.quantity || item.q;
				const key = item.key || item.k;
				if ( cart[id] ) cart[id].qty += qty;
				else cart[id] = { qty, key };
			});
		};

		const tierFor = n => tiers.find(tier => n >= tier.q) || null;
		const nextTier = n => tiers.slice().reverse().find(tier => n < tier.q) || null;

		function paint() {

			let n = 0, sub = 0;
			Object.keys(cart).forEach(id => {
				if ( prices[id] === undefined ) return;
				n += cart[id].qty;
				sub += cart[id].qty * prices[id];
			});

			el.querySelectorAll('.olt-cta').forEach(cta => {
				const qty = cart[cta.dataset.id] ? cart[cta.dataset.id].qty : 0;
				cta.innerHTML = qty
					? `<div class="olt-step-q"><button type="button" data-act="dec" aria-label="−1">−</button><span>${qty}<span class="olt-xs"> ${esc(t.inCart)}</span></span><button type="button" data-act="add" aria-label="+1">+</button></div>`
					: `<button type="button" class="olt-add" data-act="add">${esc(t.add)}</button>`;
				const card = cta.closest('.olt-card');
				const badge = card.querySelector('.olt-qbadge');
				card.classList.toggle('in-cart', qty > 0);
				badge.hidden = ! qty;
				badge.textContent = '× ' + qty;
			});

			const tier = tierFor(n);
			const next = nextTier(n);
			let msg;
			if ( ! tier ) msg = fill(t.start, { needed: lowest.q - n, pct: lowest.p + '%' });
			else if ( next ) msg = fill(t.next, { needed: next.q - n, pct: tier.p + '%', next: next.p + '%' });
			else msg = fill(t.best, { pct: tier.p + '%' });
			$('[data-olt-msg]').innerHTML = msg;

			$('[data-olt-fill]').style.width = Math.min(n, top.q) / top.q * 100 + '%';
			el.querySelectorAll('.olt-mark').forEach(mark => mark.classList.toggle('on', n >= parseInt(mark.dataset.q, 10)));
			$('[data-olt-save]').innerHTML = tier ? fill(t.save, { amount: money(Math.round(sub * tier.p / 100)) }) : '';
			$('[data-olt-checkout]').textContent = t.checkout + (cartCount ? ' (' + cartCount + ')' : '') + ' →';
			el.querySelectorAll('.olt-tier').forEach(tile => tile.classList.toggle('is-on', !! tier && parseInt(tile.dataset.pct, 10) === tier.p));

			if ( n ) bar.classList.add('is-show');
			return tier;
		}

		const getCart = () => fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
			.then(response => response.json())
			.then(data => readCart(data.items, data.item_count));

		const post = (url, body) => fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify(Object.assign(body, { sections: 'helper-cart', sections_url: window.location.pathname }))
		}).then(response => response.json().then(data => {
			if ( ! response.ok || data.status ) throw new Error(data.description || data.message || t.error);
			return data;
		}));

		function change(id, delta) {
			const current = cart[id] ? cart[id].qty : 0;
			const job = delta > 0
				? post(addUrl, { items: [{ id: parseInt(id, 10), quantity: 1 }] }).then(data => getCart().then(() => data))
				: post(changeUrl, { id: cart[id].key, quantity: current - 1 }).then(data => { readCart(data.items, data.item_count); return data; });
			return job.then(data => {
				if ( ! updateDrawer(data.sections && data.sections['helper-cart']) ) {
					document.querySelectorAll('[data-header-cart-count]').forEach(elm => elm.textContent = cartCount);
				}
			});
		}

		let toastTimer;
		function toast(html) {
			const box = $('[data-olt-toast]');
			box.innerHTML = html;
			box.classList.add('is-show');
			clearTimeout(toastTimer);
			toastTimer = setTimeout(() => box.classList.remove('is-show'), 2400);
		}

		el.addEventListener('click', e => {

			const btn = e.target.closest('[data-act]');
			if ( ! btn ) return;
			const act = btn.dataset.act;

			if ( act === 'prev' || act === 'next' ) {
				const row = btn.closest('.olt-wrap').querySelector('.olt-row');
				row.scrollBy({ left: (act === 'next' ? 1 : -1) * row.clientWidth * 0.9 });
				return;
			}

			const cta = btn.closest('.olt-cta');
			const name = cta.closest('.olt-card').querySelector('.olt-name').textContent.trim();
			const before = paint();
			el.classList.add('is-busy');

			change(cta.dataset.id, act === 'add' ? 1 : -1)
				.then(() => {
					const after = paint();
					if ( act !== 'add' ) return;
					if ( after && ( ! before || after.p > before.p ) ) {
						toast(fill(esc(t.unlocked), { pct: after.p + '%' }));
						bar.classList.add('olt-pop');
						setTimeout(() => bar.classList.remove('olt-pop'), 600);
					} else {
						toast(fill(esc(t.added), { name: esc(name) }));
					}
				})
				.catch(err => toast(esc(err.message)))
				.finally(() => el.classList.remove('is-busy'));

		});

		el.querySelectorAll('.olt-row').forEach(row => {
			const arrows = row.parentNode.querySelectorAll('.olt-arrow');
			const update = () => {
				if ( ! arrows.length ) return;
				arrows[0].disabled = row.scrollLeft < 8;
				arrows[1].disabled = row.scrollLeft + row.clientWidth > row.scrollWidth - 8;
			};
			row.addEventListener('scroll', update, { passive: true });
			update();
		});

		// "View cart" opens the theme's cart drawer when there is one
		const viewCart = $('[data-olt-viewcart]');
		viewCart.addEventListener('click', e => {
			const sidebar = document.querySelector('[data-js-site-cart-sidebar]');
			if ( sidebar && typeof sidebar.show === 'function' ) {
				e.preventDefault();
				sidebar.show();
			}
		});

		// keep in sync when the customer edits quantities in the cart drawer
		const drawerForm = document.getElementById('AjaxCartForm');
		if ( drawerForm ) drawerForm.addEventListener('cart-updated', () => getCart().then(paint));

		// lift the bar above the store's floating Rewards (Smile) button when they would overlap;
		// the Chat button sits on the same row, so this clears both
		const placeBar = () => {
			const base = window.innerWidth <= 760 ? 8 : 16;
			let bottom = base;
			const launcher = document.getElementById('smile-ui-lite-launcher-frame-container');
			if ( launcher && launcher.offsetWidth ) {
				const s = launcher.getBoundingClientRect();
				const b = bar.getBoundingClientRect();
				if ( s.right > b.left && s.left < b.right ) bottom = Math.max(base, Math.round(window.innerHeight - s.top + 10));
			}
			bar.style.bottom = bottom + 'px';
			$('[data-olt-toast]').style.bottom = bottom + bar.offsetHeight + 12 + 'px';
		};
		placeBar();
		window.addEventListener('resize', placeBar);
		[1000, 3000, 6000].forEach(ms => setTimeout(placeBar, ms)); // the launcher loads late

		if ( 'IntersectionObserver' in window ) {
			new IntersectionObserver(entries => {
				if ( ! entries[0].isIntersecting ) bar.classList.add('is-show');
			}).observe($('.olt-hero'));
		} else {
			bar.classList.add('is-show');
		}

		if ( config.endDate ) {
			const end = new Date(config.endDate).getTime();
			const box = $('[data-olt-countdown]');
			if ( ! isNaN(end) ) {
				const tick = () => {
					const s = Math.max(0, end - Date.now()) / 1000;
					const d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
					box.hidden = false;
					box.textContent = s ? t.endsIn + ' ' + (d ? d + 'd ' : '') + h + 'h ' + m + 'm' : t.ended;
				};
				tick();
				setInterval(tick, 30000);
			}
		}

		readCart(config.cart, config.count);
		paint();

	}

	const boot = () => document.querySelectorAll('[data-olt]').forEach(init);
	if ( document.readyState === 'loading' ) document.addEventListener('DOMContentLoaded', boot);
	else boot();
	document.addEventListener('shopify:section:load', boot);

})();
